export const FULL_SCREEN_LAYOUT_TEXT_COLOR = "#f0f0f0";
